var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useRef, } from 'react';
import { StyledSpanButton } from 'component/material/ButtonContained/Button';
import { FormControl, withStyles, FormHelperText, IconButton, } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
export var imgBase64 = 'data:image/png;base64,';
// const----------------------------------------------------
export var EmptyFileMsg = '請選取檔案。';
// style----------------------------------------------------
export var StyleFormControl = withStyles(function () { return ({
    root: {
        padding: '7px 5px 0',
    },
}); })(FormControl);
export var StyleFormHelperText = withStyles(function () { return ({
    root: {
        margin: '6px 10px 0',
    },
}); })(FormHelperText);
export var ImgBase64 = function (props) {
    var _a = props.src, src = _a === void 0 ? '' : _a, 
    // 1. 強制確保 download 當沒有傳入時才是 true，有傳入 false 必須是 false
    _b = props.download, 
    // 1. 強制確保 download 當沒有傳入時才是 true，有傳入 false 必須是 false
    download = _b === void 0 ? true : _b, _c = props.style, style = _c === void 0 ? { maxHeight: '180px', maxWidth: '100%' } : _c, onClick = props.onClick, other = __rest(props, ["src", "download", "style", "onClick"]);
    var _d = useState(true), base64 = _d[0], setBase64 = _d[1];
    var formattedSrc = src.startsWith('data:')
        ? src
        : (base64 ? imgBase64 : '') + src;
    // 2. 只有當 download 嚴格等於 true 時，才加上 <a> 標籤
    var isDownloadable = Boolean(download);
    var disableDownloadEvents = !isDownloadable
        ? {
            onContextMenu: function (e) { return e.preventDefault(); },
            onDragStart: function (e) { return e.preventDefault(); },
        }
        : {};
    var combinedStyle = __assign(__assign({}, style), (!isDownloadable
        ? {
            userSelect: 'none',
            WebkitUserSelect: 'none',
        }
        : {}));
    var imgJsx = (React.createElement("img", __assign({ alt: "upload img", src: formattedSrc, onError: function () { return setBase64(false); }, style: combinedStyle, onClick: onClick }, other, disableDownloadEvents)));
    // 3. 關鍵邏輯：如果是 false，直接回傳純 <img>，完全淘汰 <a> 標籤
    if (!isDownloadable) {
        return imgJsx;
    }
    return (React.createElement("a", { href: formattedSrc, download: true }, imgJsx));
};
export var ImgUpload = function (props) {
    var _a = props.deleteBtn, deleteBtn = _a === void 0 ? true : _a, _b = props.accept, accept = _b === void 0 ? '.jpg,.png' : _b, name = props.name, value = props.value, onChange = props.onChange, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _d = props.required, required = _d === void 0 ? false : _d, _e = props.inputRef, inputRef = _e === void 0 ? useRef() : _e, _f = props.verifyBeforeChange, verifyBeforeChange = _f === void 0 ? false : _f, other = __rest(props, ["deleteBtn", "accept", "name", "value", "onChange", "error", "helperText", "verifiers", "required", "inputRef", "verifyBeforeChange"]);
    var _g = useState(true), urlExist = _g[0], setUrlExist = _g[1];
    var _h = useState(''), message = _h[0], setMessage = _h[1];
    var _j = useState(verifyBeforeChange), FirstVerify = _j[0], setFirstVerify = _j[1];
    var handleFileChange = function (e) {
        var files = e.target.files;
        if (!deleteBtn && !files[0]) {
            return;
        }
        if (onChange) {
            onChange(e);
            inputRef.current.value = ''; // 清空 input File 裡的資料，選同一張時才會再觸發
        }
    };
    if (required) {
        verifiers.push({ func: function (img) { return !img; }, text: EmptyFileMsg });
    }
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!FirstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗使用者設定之 verifier, 要驗空值
        if (verifiers.length > 0) {
            var veriObj = verifiers.find(function (obj) { return obj.func(value); });
            if (veriObj) {
                setMessage(veriObj.text);
                return;
            }
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [value, verifyBeforeChange]);
    var DeleteBtn = !deleteBtn ? (React.createElement(React.Fragment, null)) : (React.createElement(IconButton, { "aria-label": "delete", style: { position: 'absolute', right: 0, top: 0, padding: 3 }, onClick: function (e) {
            e.preventDefault(); // 避免觸發之後的 event
            inputRef.current.value = '';
            if (onChange) {
                onChange({
                    target: {
                        name: name,
                        files: [],
                    },
                });
            }
        } },
        React.createElement(CancelIcon, { color: "action", fontSize: "large", style: {
                backgroundColor: 'white',
                borderRadius: 20,
                opacity: 0.8,
            } })));
    var getElement = function () {
        return urlExist ? (React.createElement(React.Fragment, null,
            DeleteBtn,
            React.createElement(ImgBase64, { download: false, src: value, onError: function () { return setUrlExist(false); }, style: { maxHeight: '180px', maxWidth: '100%' } }))) : (React.createElement(StyledSpanButton, { text: "\u6A94\u6848\u4E0A\u50B3" }));
    };
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("label", { style: { width: 'fit-content', position: 'relative' } },
            React.createElement("input", __assign({ type: "file", required: required && !value, name: name, accept: accept, ref: inputRef, style: { width: 150, opacity: 0, position: 'absolute' }, onChange: handleFileChange }, other)),
            value instanceof File ? (React.createElement(React.Fragment, null,
                DeleteBtn,
                React.createElement("img", { src: URL.createObjectURL(value), alt: "", style: { maxHeight: '180px', maxWidth: '100%' } }))) : (getElement())),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
